module.exports = __webpack_public_path__ + "img/mastercard-alt.d01afc86.svg";